import React from 'react';
import { motion } from 'framer-motion';
export const ProductSection = () => {
  const features = [{
    title: 'Five Water Modes',
    description: 'Sparkling, ambient, chilled, hot, and auto-fill at your fingertips'
  }, {
    title: 'Intuitive Interface',
    description: 'Color-coded buttons with LED indicators for effortless operation'
  }, {
    title: 'Premium Materials',
    description: 'Brushed stainless steel construction with precision glass dispensers'
  }, {
    title: 'Compact Footprint',
    description: 'Sleek countertop design that fits seamlessly into any space'
  }, {
    title: 'Advanced Filtration',
    description: 'Multi-stage purification for exceptional taste and purity'
  }, {
    title: 'Commercial Grade',
    description: 'Engineered for high-volume use in restaurants, hotels, and offices'
  }];
  return <section className="relative bg-white" data-id="element-188">
      {/* Header */}
      <div className="container mx-auto px-4 md:px-6 lg:px-12 pt-20 md:pt-32 pb-12 md:pb-20" data-id="element-189">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="max-w-3xl" data-id="element-190">
          <div className="inline-block px-3 md:px-4 py-1 md:py-1.5 bg-gray-100 rounded-full text-xs font-medium text-gray-700 mb-4 md:mb-6 uppercase tracking-wider" data-id="element-191">
            Introducing
          </div>
          <h2 className="text-5xl md:text-8xl font-light mb-4 md:mb-8 tracking-tight" data-id="element-192">
            WELLHAUS™ Drinkstation
          </h2>
          <p className="text-lg md:text-2xl text-gray-600 font-light leading-relaxed" data-id="element-193">
            Precision engineering meets elegant design. Five water modes,
            infinite possibilities.
          </p>
        </motion.div>
      </div>
      {/* Main Product Showcase */}
      <div className="container mx-auto px-4 md:px-6 lg:px-12 pb-0" data-id="element-194">
        <motion.div initial={{
        opacity: 0,
        scale: 0.98
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 1
      }} className="relative" data-id="element-195">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/xjJo8Ho23ZpK2BJfZST5PM/WATER-VINCI-v2-2025-01.932_copy.webp" alt="WELLHAUS Drinkstation Water Machine" className="w-full h-auto" data-id="element-196" />
        </motion.div>
      </div>
      {/* Features Grid */}
      <div className="container mx-auto px-4 md:px-6 lg:px-12 -mt-10 md:-mt-20 pb-20 md:pb-32 relative z-10" data-id="element-197">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4 max-w-6xl mx-auto" data-id="element-198">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white/95 backdrop-blur-sm p-5 md:p-6 rounded-xl border border-gray-100 shadow-lg" data-id="element-199">
              <h3 className="text-sm md:text-base font-medium mb-1.5 md:mb-2" data-id="element-200">
                {feature.title}
              </h3>
              <p className="text-xs md:text-sm text-gray-600 leading-relaxed" data-id="element-201">
                {feature.description}
              </p>
            </motion.div>)}
        </div>
      </div>
      {/* Control Panel Detail */}
      <div className="relative bg-gradient-to-b from-gray-50 to-white py-20 md:py-32" data-id="element-202">
        <div className="container mx-auto px-4 md:px-6 lg:px-12" data-id="element-203">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-16 items-center max-w-7xl mx-auto" data-id="element-204">
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} className="order-2 lg:order-1" data-id="element-205">
              <div className="space-y-4 md:space-y-6" data-id="element-206">
                <div className="inline-block px-3 md:px-4 py-1 md:py-1.5 bg-water-blue rounded-full text-xs font-medium text-gray-700 uppercase tracking-wider" data-id="element-207">
                  Interface Design
                </div>
                <h3 className="text-3xl md:text-6xl font-light tracking-tight" data-id="element-208">
                  Precision at Your Fingertips
                </h3>
                <p className="text-base md:text-lg text-gray-600 leading-relaxed" data-id="element-209">
                  Each button is meticulously engineered with LED feedback and
                  intuitive color coding for effortless operation.
                </p>
                <div className="pt-2 md:pt-4 space-y-3 md:space-y-4" data-id="element-210">
                  <div className="flex items-start gap-3" data-id="element-211">
                    <div className="flex-shrink-0 w-1.5 h-1.5 rounded-full bg-water-accent mt-2" data-id="element-212" />
                    <div data-id="element-213">
                      <p className="text-xs md:text-sm font-medium text-gray-900" data-id="element-214">
                        LED Status Indicators
                      </p>
                      <p className="text-xs md:text-sm text-gray-600" data-id="element-215">
                        Real-time feedback for every operation
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3" data-id="element-216">
                    <div className="flex-shrink-0 w-1.5 h-1.5 rounded-full bg-water-accent mt-2" data-id="element-217" />
                    <div data-id="element-218">
                      <p className="text-xs md:text-sm font-medium text-gray-900" data-id="element-219">
                        Color-Coded System
                      </p>
                      <p className="text-xs md:text-sm text-gray-600" data-id="element-220">
                        Intuitive operation without training
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3" data-id="element-221">
                    <div className="flex-shrink-0 w-1.5 h-1.5 rounded-full bg-water-accent mt-2" data-id="element-222" />
                    <div data-id="element-223">
                      <p className="text-xs md:text-sm font-medium text-gray-900" data-id="element-224">
                        Premium Touch Response
                      </p>
                      <p className="text-xs md:text-sm text-gray-600" data-id="element-225">
                        Tactile feedback for confident control
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} className="order-1 lg:order-2" data-id="element-226">
              <div className="relative rounded-xl md:rounded-2xl overflow-hidden shadow-2xl" data-id="element-227">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/4hu4j2Ks3jCJE714aDLDqG/WATER-VINCI-v2-2025-01.963.webp" alt="WELLHAUS Drinkstation Control Panel" className="w-full h-auto" data-id="element-228" />
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
};